import { ReactElement, ReactNode } from 'react';
import { Field, Input, Button, makeStyles } from '@fluentui/react-components';

type TDialogPickerFieldProps = {
  label: string;
  value: string;
  placeholder?: string;
  disabled?: boolean;
  onClick: () => void;
  icon?: ReactElement;
  warning?: string;
  action?: ReactNode;
};

const useStyles = makeStyles({
  clickable: {
    cursor: 'pointer',
    '& input': { cursor: 'pointer' },
  },
});

const DialogPickerField = ({
  label,
  value,
  placeholder,
  disabled,
  onClick,
  icon,
  warning,
  action,
}: TDialogPickerFieldProps) => {
  const classes = useStyles();
  return (
    <Field label={label} validationState={warning ? 'warning' : undefined} validationMessage={warning}>
      <div className="flex items-center gap-1">
        <Input
          readOnly
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          onClick={disabled ? undefined : onClick}
          className={disabled ? 'grow' : `grow ${classes.clickable}`}
          contentAfter={
            icon ? (
              <Button
                appearance="transparent"
                size="small"
                icon={icon}
                disabled={disabled}
                onClick={(e) => {
                  e.stopPropagation();
                  onClick();
                }}
              />
            ) : undefined
          }
        />
        {action}
      </div>
    </Field>
  );
};

export { DialogPickerField };
